import ReactTooltip from "react-tooltip";
import Division from "../Division";
import Header from "../Header";
import Lateral from "../Lateral";
import { FaArrowAltCircleLeft, FaCog } from "react-icons/fa";
import Title from "../Title";
import { Link } from "react-router-dom";

export default function CadBasePage({carrying, title, URLToBack, children}){
    const childrens = {
        inputs: children[0],
        buttons: children[1]
    }

    return (
        <div>
            <Header />
            <Division />
            <Lateral />
            <ReactTooltip />
            
            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando..</span>
                    <FaCog icon="spinner" className="spinner" />
                </div>
            </div>}
            {!carrying && <div className="content">
                    <Title name={title}>
                        <Link to={URLToBack}>
                            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
                        </Link>
                    </Title>
                    <div className="container">
                        <form className="form-profile customers">
                            <div className="containerGroupData">
                                <h2>Dados Cadastrais</h2>
                                <hr></hr>
                                {childrens.inputs}
                            </div>
                            <br />
                            <div className="formDiv">
                                {childrens.buttons}
                            </div>
                        </form>
                    </div>
                </div>
            }
        </div>
    )
}